// This is used to convert a given timestamp to the browser's local time
// and display it in a human-readable format.
//
// The timestamp is expected to be in ISO 8601 format.
//
// The hourFormat, minuteFormat, and secondFormat are used to format the
// hour, minute, and second respectively.
//
// The timeStyle is used to format the time in a shorthand format.
//
// The timeStyle can be one of the following:
// - "short"
// - "medium"
// - "full"
// - "long"
//
// Usage:
// <div data-controller="local-timestamp"
//      data-timestamp="2024-01-01T00:00:00Z"></div>
//
// <div data-controller="local-timestamp"
//      data-timestamp="2024-01-01T00:00:00Z"
//      data-hour-format="numeric"
//      data-minute-format="2-digit"
//      data-second-format="2-digit"
//      data-time-style="short"></div>
//
// More information about the formats can be found here:
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/toLocaleTimeString#specifications

import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    hourFormat: { type: String, default: "numeric" },
    minuteFormat: { type: String, default: "2-digit" },
    secondFormat: { type: String, default: undefined },
    timeStyle: { type: String, default: undefined }
  }

  connect() {
    this.convertTimestamp()
  }

  convertTimestamp() {
    const timestamp = this.element.getAttribute('data-timestamp')
    if (timestamp) {
      const date = new Date(timestamp)

      const options = {}

      // If timeStyle is provided, use that (it's a shorthand format)
      if (this.timeStyleValue) {
        options.timeStyle = this.timeStyleValue
      } else {
        if (this.hourFormatValue) options.hour = this.hourFormatValue
        if (this.minuteFormatValue) options.minute = this.minuteFormatValue
        if (this.secondFormatValue) options.second = this.secondFormatValue
      }

      this.element.textContent = date.toLocaleTimeString([], options)
    }
  }
}